module.exports = __webpack_public_path__ + "static/Theinhardt-Medium-Italic-3aa0dc49f87295c0b92d7452502119cd.woff2";